import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../../administration/userManagement/hierarchyAssignmentsPanelTab/reducerGenerator'

const hierarchyAssignmentsPanelReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsPanelReducer.initialState,
}

const cptAssignmentsList = handleActions({
    ...hierarchyAssignmentsPanelReducer.handlers,
}, initialState)

export default cptAssignmentsList



// WEBPACK FOOTER //
// ./web/js/userProfile/cptAssignmentsList/reducer.js